import * as EvaluationsClient from '../clients/EvaluationsClient'
import * as ReportsClient from '../clients/ReportsClient'

export default class SuccessByDatasetForTagVersion {
  constructor() {
  }
  async load(tagVersion, query) {
      var evaluations = await EvaluationsClient.getEvaluations(query)
      var evaluationsForTagVersion = evaluations.filter(e => e.tagVersion === (tagVersion))
      var obj = {}
      var datasets = []
      for (var i = 0; i < evaluationsForTagVersion.length; i++) {
        var evaluation = evaluationsForTagVersion[i]
        var configName = evaluation.name
        var datasetNumber = evaluation.datasetNumber || evaluation.dataset.number
        if (datasets.indexOf(datasetNumber) === -1) datasets.push(datasetNumber)
        if (!obj[configName]) obj[configName] = {}
        if (!obj[configName][datasetNumber]) obj[configName][datasetNumber] = {}
        obj[configName][datasetNumber].winPercentage = (evaluation.winPercentage * 100).toFixed(2)
      }

      var configArr = Object.keys(obj).map(key => {
        return {configName: key, datasets: obj[key]}
      })
      this.datasets = datasets
      this.evaluations = configArr
  }
  loadForPredictionConfig(predictionConfigName) {
    return new Promise ((resolve, reject) => {
      EvaluationsClient.getEvaluations()
      .then(evaluations => {
        var tagVersion = getHighestTagVersion(evaluations)
        var evaluationsForTagVersion = evaluations.filter(e => e.tagVersion === (tagVersion))
        var obj = {}
        var datasets = []
        for (var i = 0; i < evaluationsForTagVersion.length; i++) {
          var evaluation = evaluationsForTagVersion[i]
          var configName = evaluation.name
          var datasetNumber = evaluation.datasetNumber || evaluation.dataset.number
          if (datasets.indexOf(datasetNumber) === -1) datasets.push(datasetNumber)
          if (!obj[configName]) obj[configName] = {}
          obj[configName][datasetNumber] = (evaluation.winPercentage * 100).toFixed(2)
        }

        var configArr = Object.keys(obj).map(key => {
          return {configName: key, datasets: obj[key]}
        })
        resolve( {
          datasets: datasets,
          evaluations: configArr.filter(c => c.configName === predictionConfigName)
        })
      })
    })
  }
  addReportFlags() {
    return new Promise ((resolve, reject) => {
      ReportsClient.getEvaluationReports()
      .then(evaluationReports => {
        this.evaluations.forEach(evaluation => {
          Object.keys (evaluation.datasets).forEach(dataset => {
            if (evaluationReports[dataset] && evaluationReports[dataset].main && evaluationReports[dataset].main.indexOf(evaluation.configName) > -1) {
              evaluation.datasets[dataset].report = true
            }
          })
        })
        resolve()
      })
    })

  }
}

function getHighestTagVersion (evaluations) {
  return evaluations.sort((a,b) => b.tagVersion - a.tagVersion)[0].tagVersion
}
